import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getCampaignName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executions.campaignname'],
);

export const getSchema = createSelector(getLiteralsState, ({ literals }) => literals['liquid.schema']);

export const getCountry = createSelector(getLiteralsState, ({ literals }) => literals['liquid.country']);

export const getChannel = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionschannel'],
);

export const getStartDate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.campaign.startdate']);

export const getEndDate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.campaign.enddate']);

export const getId = createSelector(getLiteralsState, ({ literals }) => literals['liquid.campaign.executionsid']);

export const getDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionsdescription'],
);

export const getDate = createSelector(getLiteralsState, ({ literals }) => literals['liquid.campaign.executionsdate']);

export const getTableSchema = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionsschema'],
);

export const getTableCountry = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionscountry'],
);

export const getTableChannel = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionschannel'],
);

export const getTableCost = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionscost'],
);

export const getTableGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionsgroup'],
);

export const getTableMembers = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionsrecipients'],
);

export const getTableProgress = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionprogress'],
);

export const getExecutionDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.execution.execution_date'],
);

export const getInsertNumeric = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.execution.numeric'],
);

export const getInsertNewExecDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.execution.date'],
);

export const getCampaignProcessed = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.wizard.processed'],
);

export const getDownloadRecipientsHeader = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.header'],
);

export const getDownloadRecipients = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexecdownloadrecipients'],
);

export const getExecutionId = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexecid'],
);

export const getExecutionTitle = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexectitle'],
);

export const getExecutionDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexecdescription'],
);

export const getCampaignExecutionDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexecdate'],
);

export const getControlGroup = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexeccontrolgroup'],
);

export const getExcluded = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.campaign.executionlinesmodal.campexecexcluded'],
);
